import { NotificationConfigurationDto } from "@/Common/Api/Services/Dto/NotificationConfigurationDto";
import { Guid } from "@/Common/Models/Guid";
import { ServiceComboItemType } from "@/Common/Models/Services/Enums/ServiceComboItemType";
import { ServiceComboTargetClientele } from "@/Common/Models/Services/Enums/ServiceComboTargetClientele";
import { ServicePublishingRule } from "@/Common/Models/Services/IServicePublishingConfig";
import { ServiceComboDefinitionItemDTO } from "@/Common/Models/Services/ServiceOrComboTableItem";
import { Timeframe } from "@/Common/Models/Timeframe";

class ServiceDefinition {
    public Id: Guid;
    public DefaultDuration: number;
    public Code: string;
    public SpecializationLookupId: string;
    public SiteId: Guid;

    public NameLookupId: string;
    public OnlineGroupId: string;
    public OnlineNameLookupId: string;
    public OnlineDescriptionLookupId: string;
    public OnlineDisclaimerLookupId: string;

    public Price: number;
    public IsServiceUrgent: boolean;
    public IsAvailableOnline: boolean;
    public OnlineClienenteleCible: ServiceComboTargetClientele;
    public PublishingRule: ServicePublishingRule;
    public PublishingTimeframe: Timeframe;
    public IsNotifyPatientDisabledByDefault: boolean;
    public IsTeleconsultation: boolean;
    public QuestionnaireId: string;
    public LicenceOrganisationSpecialisationId: string;
    public NotificationConfiguration: NotificationConfigurationDto;
}

class ServiceComboDefinition {
    public ComboId: number;
    public ComboItemId: number;
    public ComboItemPosition: number;
    public ServiceDefinitionId: Guid; // Does not apply for Combo
    public ServiceDefinitionIds: ServiceComboDefinitionItemDTO[]; // only for Combo
    public PrimaryServiceDefinitionId: Guid;
    public Type: ServiceComboItemType = ServiceComboItemType.Combo;

    // Other
    public Name: string;
    public IsPrimaryEmployeeService: boolean;
    public NameLookupId: string;
    public OnlineGroupId: string;
    public OnlineNameLookupId: string;
    public OnlineDescriptionLookupId: string;
    public OnlineDisclaimerLookupId: string;
    public SiteId: Guid;
    public Price: number;
    public IsPriceIncludingTaxes: boolean;
    public SpecializationLookupId: string;
    public ComboItemServiceId: number;
    public IsServiceUrgent: boolean;
    public OnlineClienenteleCible: ServiceComboTargetClientele;
    public PublishingRule: ServicePublishingRule;
    public PublishingTimeframe: Timeframe;
    public IsAvailableOnline: boolean;
    public IsNotifyPatientDisabledByDefault: boolean;
    public IsPriceWithTaxes: boolean;
    public IsTeleconsultation: boolean;
    public QuestionnaireId: string;
    public LicenceOrganisationSpecialisationId: string;
    public NotificationConfiguration: NotificationConfigurationDto;
}

export { ServiceComboDefinition, ServiceDefinition };
